<template>
    <div>
        <div class="hts-categorys-index-list">
            <div class="hts-categorys-index-list__container">
                <div class="mt-5">
                    <div class="box-button">
                        <div class="">
                            <hts-form-button
                                type="submit"
                                color="main"
                                icon-name="hi-plus-circle-icon"
                                icon-position="right"
                                @click="showSlideOverAddcategory = true">
                                {{ $t('labels.addcategory') }}
                            </hts-form-button>
                        </div>
                    </div>
                </div>
                <div class="body">
                    <div>
                        <div class="shadow border-b border-gray-200 sm:rounded-lg">
                            <list-category v-loading="isLoading" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <add-category
            :show="showSlideOverAddcategory"
            @close="showSlideOverAddcategory = false" />
    </div>
</template>

<script setup lang="ts">
/*
  TODO: API data categorys list
  handle loading page
*/

const showSlideOverAddcategory = ref(false)

let timeOut: any
const isLoading = ref(true)
const time = 1000
const handleLoading = () => {
  clearTimeout(timeOut)
  timeOut = setTimeout(() => {
    isLoading.value = false
  }, time)
}
handleLoading()
/* loading page */
</script>
